<template>
  <div style="width: 100%; text-align: right;">
    <ul class="pagination" :id="paginatorId">
      <li class="pagination-edges-li">
        <a class="pagination-edges-li-a" href="javascript:void(0);"
           aria-label="Previous"
           @click="tabClicked(current - 1)" >
          <span style="color: inherit;" aria-hidden="true"><</span>
        </a>
      </li>
      <li class="pagination-middle-li" v-for="(num) in numberList" v-bind:key="'tabListid_' + num">
        <a href="javascript:void(0);" :class="[num == current ? 'active' : '']" @click="tabClicked(num)">{{num}}</a>
      </li>
      <li class="pagination-edges-li">
        <a  href="javascript:void(0);"
            aria-label="Next" @click="tabClicked(current + 1)">
          <span aria-hidden="true">></span>
        </a>
      </li>

      <li class="pagination-total-pages">
        共{{total}}页
      </li>
      <li class="pagination-inputs-li">
        跳转&nbsp;<input type="number" id="bottom_paginator_input" min="1" >&nbsp;页
        <input type="button" value="GO" id="paginator_go_button" @click="goto">
      </li>
    </ul>
  </div>
</template>

<script>
import RedEditImg from "../assets/shl_editing_red_img.png";
import GoldEditImg from "../assets/shl_editing_gold_img.png";

export default {
  name: "BottomPaginator",
  props: {
    current: {
      type: Number,
      value: 0,
    },
    total: {
      type: Number,
      value: 0
    },
    paginatorType: {
      type: Number,
      value: 0
    }
  },
  data() {
    return {
      page: 5,
    }
  },
  computed: {
    numberList() {
      let currentPage = this.current;
      let totalNumber = this.total;
      let page = this.page;

      let separator = Math.floor(page / 2);
      let minPage = currentPage - separator;
      let maxPage = currentPage + separator;
      if (minPage <= 0) {

        minPage = 1;
        maxPage = minPage + page - 1;
      }

      if (maxPage > totalNumber) {
        maxPage = totalNumber
      }

      if (maxPage -  minPage >= page) {
        maxPage = minPage + page -1;
      }

      let list = Array.from({length: (maxPage - minPage + 1)}, (_, i) => (i + minPage));
      return list;
    },

    paginatorId() {
      return this.paginatorType == 0 ? 'note_bottom_paginator_gold' : 'note_bottom_paginator_red';
    }

  },
  mounted() {
  },
  methods: {
    tabClicked(index) {
      if (index > 0 && index <= this.total) {
        this.$emit('itemClicked', {
          index
        });
      }
    },
    goto() {
      let index = $("#bottom_paginator_input").val();
      $("#bottom_paginator_input").val('');
      this.tabClicked(index);
    }
  }
}
</script>

<style scoped>

  input {
    outline: none;
  }

  #note_bottom_paginator_gold, #note_bottom_paginator_red {
    align-self: flex-end;
  }

  .pagination {
    text-align: left;
  }


  .pagination li {
    display: inline-block;
    vertical-align: middle;
    margin-top: 5px;
  }


  .pagination-middle-li a {
    display: block;
    color: #333;
    font-size: 12px;
    margin-left: 3px;
    padding-top: 3px;
    padding-bottom: 3px;
    padding-left: 8px;
    padding-right: 8px;
  }

  #note_bottom_paginator_gold .pagination-middle-li a {
    border: solid 1px #cbb042;
  }

  #note_bottom_paginator_red .pagination-middle-li a {
    border: solid 1px #fc1a34;
  }


  .pagination-middle-li a:visited {
    background-color: white;
    color: #333;
  }

  #note_bottom_paginator_gold .pagination-middle-li a.active, #note_bottom_paginator_gold .pagination-middle-li a:hover {
    background-color: #cbb042;
    color: white;
  }

  #note_bottom_paginator_red .pagination-middle-li a.active, #note_bottom_paginator_red .pagination-middle-li a:hover {
    background-color: #fc1a34;
    color: white;
  }

  .pagination-middle-li a.active {
    pointer-events: none;
  }

  .pagination-edges-li a {
    font-size: 1rem;
    font-weight: bold;
    border: none;
    padding-right: 3px;
  }

  #note_bottom_paginator_gold .pagination-edges-li a {
    color: #cbb042;
  }

  #note_bottom_paginator_red .pagination-edges-li a {
    color: #fc1a34;
  }

  .pagination-edges-li a:hover {
    background-color: white;
    color: #999;
  }


  .pagination-inputs-li {
    color: #333;
    font-size: 1rem;
    margin-left: 15px;
  }


  #bottom_paginator_input {
    border-radius: 4px;
    color: #333;
    font-size: 1rem;
    max-width: 50px;
    min-width: 25px;
  }

  #note_bottom_paginator_gold #bottom_paginator_input {
    border: solid 1px #cbb042;
  }

  #note_bottom_paginator_red #bottom_paginator_input {
    border: solid 1px #fc1a34;
  }

  #note_bottom_paginator_gold #paginator_go_button {
    background-color: #cbb042;
  }

  #note_bottom_paginator_red #paginator_go_button {
    background-color: #fc1a34;
  }

  #paginator_go_button {
    border: solid 1px transparent;
    height: 20px;
    border-radius: 10px;
    font-size: 0.8rem;
    color: white;
    padding-left: 10px;
    padding-right: 10px;
    margin-left: 10px;
  }


  #note_bottom_paginator_gold .pagination-total-pages {
    font-size: 12px;
    color: #cbb042;
  }

  #note_bottom_paginator_red .pagination-total-pages {
    font-size: 12px;
    color: #fc1a34;
  }

</style>



// WEBPACK FOOTER //
// src/components/BottomPaginator.vue